<template>
    <div class="modal fade" id="viewIdCardPrintModal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header bg-aqua">
                <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">Employee ID Card</h4>
                </div>
                <div class="modal-body printing" id="printIdCardPrintModal">
                    <div class="card card-primary card-outline padding-sm" style="border-style: solid; padding: 6px 6px 6px 6px;">
                        
                        <!-- <img
                            class="profile-user-img img-fluid"
                            :src= this.logo
                            alt="company logo"
                            style="width:65px; height: 52px"
                        />
                        <br> -->
                        <div v-if="getCompanyRecord.companyName" class="title">
                            <h1>{{ getCompanyRecord.companyName.toUpperCase() }}</h1>
                            <p class="text-muted text-center">
                                ( {{ getCompanyRecord.address }} )
                           </p>
                        </div>
                        <div v-if="empInfo.user" class="card-body box-profile">
                            <div class="text-center">
                            <img
                                class="profile-user-img img-fluid img-circle"
                                :src= this.photo
                                alt="User profile picture"
                                style="height: 112px"
                            />
                            </div>
                            
                            <h1>
                            {{ empInfo.user.name.toUpperCase() }}
                            </h1>

                            <p class="text-muted text-center">
                           ( {{ empInfo.designation.name.toUpperCase() }} )
                           </p>

                                <b>Employee Code</b>
                                <a class="pull-right">{{ empInfo.user.code }}</a><br>
                            <!-- <li class="list-group-item">
                                <b>Branch</b>
                                <a class="pull-right">{{ empInfo.branch.name }}</a>
                            </li> -->
                                <b>Phone Number</b>
                                <a class="pull-right">{{ empInfo.user.mobile }}</a><br>
                                <b>City</b>
                                <a class="pull-right">{{ empInfo.city }}</a><br>
                                <!-- <b>DOB</b>
                                <a class="pull-right">{{ empInfo.dob }}</a><br>
                                <b>Joining Date</b>
                                <a class="pull-right">{{ empInfo.joiningDate }}</a><br> -->
                        </div>
                        <div v-if="getCompanyRecord.companyName" class="title">
                            <p>
                            {{ empInfo.user.name.toUpperCase() }}
                            </p>
                        </div>
                        <!-- /.card-body -->
                    </div>
                </div>
                <div class="modal-footer text-center">
                <button
                    type="button"
                    class="btn btn-primary"
                    @click="printIdCardPrintModal"
                >
                    PRINT
                </button>
                <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                >
                    CLOSE
                </button>
                </div>
            </div>
        <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
</template>
<script>
import { Printd } from 'printd'
export default({
  name: 'EmployeeIDCard',
  data () {
    return {
      cssText: `.printing {
        font-family: sans-serif;
        text-align: center;
        background-color: red;
        print-color-adjust: exact;
        -webkit-print-color-adjust: exact;
      }
      p {
        text-align: justify;
      }
      h3 {
        text-align: center;
      }
      @page {
        size: 2.125in 3.375in;
      }`
    }
  },
  methods: {
    printIdCardPrintModal () {
      const d = new Printd()
      d.print(document.getElementById('printIdCardPrintModal'), [this.cssText])
      // Get HTML to print from element
    }
  },
  props: {
    empInfo: {},
    photo: '',
    logo: '',
    getCompanyRecord: {}
  }
})
</script>




// WEBPACK FOOTER //
// EmployeeIdCard.vue?7c629dc2